import isInIframe from '../../../@Future/Util/Iframe/IsInIframe';

const isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;

// https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript/18706818
const isWindows7 = /(Windows 7|Windows NT 6.1)/.test((navigator as any).oscpu);

export const isInIe11AndWindows7AndIframe = isIE11 && isWindows7 && isInIframe();
